import { render, staticRenderFns } from "./RestartAccount.vue?vue&type=template&id=6ef6325e&scoped=true&"
import script from "./RestartAccount.vue?vue&type=script&lang=js&"
export * from "./RestartAccount.vue?vue&type=script&lang=js&"
import style0 from "./RestartAccount.vue?vue&type=style&index=0&id=6ef6325e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef6325e",
  null
  
)

export default component.exports